import { useSyncExternalStore } from 'react'

/**
 * Whether a CSS media query matches, kept live. For choosing what to MOUNT at
 * a breakpoint (a component rendered twice and hidden by CSS still fetches and
 * runs twice). Never use it to detect touch: iPadOS Safari reports a fine
 * pointer and hover, so a touch question asked of a media query gets the
 * wrong answer on an iPad.
 *
 * Where `matchMedia` does not exist (tests, old embeds) it answers `fallback`.
 */
export function useMediaQuery(query: string, fallback = true): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {}
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    () =>
      typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(query).matches
        : fallback,
    () => fallback,
  )
}

/** Tailwind's `lg` breakpoint. */
export const LG_UP = '(min-width: 1024px)'
